import React from 'react';

function PaymentIcon({ className = '', fill = '#212121' }) {
	return (
		<svg
			className={className}
			width='48'
			height='48'
			viewBox='0 0 48 48'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_1357_45457)'>
				<path
					d='M44 8H4V40H44V8ZM40 36H8V24H40V36ZM40 16H8V12H40V16Z'
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_1357_45457'>
					<rect width='48' height='48' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default PaymentIcon;
